import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Dates from "../components/Dates";
import AboutUs from "../components/AboutUs";
import Footer from "../components/Footer";
import ContactUs from "../components/ContactUs";
import Speakers from "../components/Speakers";
import Sponsors from "../components/Sponsors";
import Call from "../components/Call";
import Countdown from "../components/Countdown";
import TrackDetails from "../components/TrackDetails";
import AdvisoryCommittee from "../components/AdvisoryCommittee";
import Marque from "../components/Marque";
import { client } from "../config/prismic";

const Home = () => {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("home");
      setHome(response.results[0]?.data);
    };
    fetchData();
  }, []);
  return (
    <div>
      {/* <Marque /> */}
      <Header />
      <Hero home={home} />
      <AboutUs />
      {/* <Countdown /> */}
      <TrackDetails />
      <Dates />
      <Speakers />
      {/* <Sponsors /> */}
      {/* <Call /> */}
      <ContactUs />
      <Footer />
    </div>
  );
};

export default Home;
